"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./BaseHeader.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _MobileMenuItem = _interopRequireDefault(require("./MobileMenuItem"));

var _classnames = _interopRequireDefault(require("classnames"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _HeaderItem = require("../../mixins/HeaderItem");

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _class, _class2, _descriptor, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var BaseHeader = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseHeader, _React$Component);

  var _super = _createSuper(BaseHeader);

  function BaseHeader(props) {
    var _this;

    _classCallCheck(this, BaseHeader);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "mobileMenuOpen", _descriptor, _assertThisInitialized(_this));

    _this.mobileMenuOpen = false;
    return _this;
  }

  _createClass(BaseHeader, [{
    key: "handleMobileMenuClick",
    value: function handleMobileMenuClick() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$session, _this$props$session2;

      return /*#__PURE__*/_react.default.createElement("header", {
        className: (0, _classnames.default)("page-header", this.props.className)
      }, /*#__PURE__*/_react.default.createElement(_HeaderItem.BaseHeaderContext.Provider, {
        value: {
          selectedHeaderItem: this.props.selectedHeaderItem,
          isMobileMenu: false,
          enableAnimations: true,
          disableTransform: this.props.disableDesktopTransform
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "full-screen-header"
      }, this.props.children)), /*#__PURE__*/_react.default.createElement("div", {
        className: "small-screen-header"
      }, /*#__PURE__*/_react.default.createElement(_HeaderItem.BaseHeaderContext.Provider, {
        value: {
          selectedHeaderItem: this.props.selectedHeaderItem,
          isMobileMenu: this.mobileMenuOpen,
          enableAnimations: false,
          disableTransform: this.props.disableMobileTransform
        }
      }, /*#__PURE__*/_react.default.createElement(_MobileMenuItem.default, {
        className: "small-screen-header",
        isLoggedIn: (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.isLoggedIn,
        url: "/",
        enableOnFocus: false,
        handleMobileMenuClick: this.handleMobileMenuClick,
        requestInfoUrl: (_this$props$session2 = this.props.session) === null || _this$props$session2 === void 0 ? void 0 : _this$props$session2.requestInfoUrl
      }, this.props.mobileRender ? this.props.mobileRender : this.props.children))));
    }
  }]);

  return BaseHeader;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  className: _propTypes.default.string,
  mobileRender: _propTypes.default.element,
  disableMobileTransform: _propTypes.default.bool,
  disableDesktopTransform: _propTypes.default.bool
}), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "mobileMenuOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "handleMobileMenuClick", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleMobileMenuClick"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(BaseHeader, {
  sessionStore: {
    session: "session"
  }
});

exports.default = _default;